import { PROFILES, ADMIN_ROLES } from 'CONST';

export const USER_WRITE = [...ADMIN_ROLES, PROFILES.administrador];
export const USER_READ = [...ADMIN_ROLES, PROFILES.administrador];

export const USER_WRITE_CLIENTS = [PROFILES.administradorClientes];
export const USER_READ_CLIENTS = [PROFILES.administradorClientes];

export const LDAP_USERS_READ = ADMIN_ROLES;

export const CLIENT_WRITE = [
  ...ADMIN_ROLES,
  PROFILES.consultaEspecial,
  PROFILES.comercialGarantia,
  PROFILES.comercialCredito,
  PROFILES.gerenteOperaciones,
];

export const CLIENT_READ = [
  ...ADMIN_ROLES,
  PROFILES.consultaEspecial,
  PROFILES.comercialGarantia,
  PROFILES.gerenteGarantia,
  PROFILES.suscripcionGarantia,
  PROFILES.comercialCredito,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoCredito,
  PROFILES.fiscalia,
  PROFILES.actuariado,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
  PROFILES.riesgoOperacional,
  PROFILES.siniestros,
  PROFILES.recuperoSiniestros,
  PROFILES.consultaBasico,
];
